// extracted by mini-css-extract-plugin
export default {"dropdown-option-max-with":"cY9aHYd_"};